import { graphql } from '../../../gql';

export const GET_REPLIES_QUERY = graphql(`
  query getReplies($parentPostId: String!, $limit: Int, $nextToken: String) {
    getReplies(parentPostId: $parentPostId, limit: $limit, nextToken: $nextToken) {
      items {
        ...ReplyCardFields
        score
      }
      nextToken
    }
  }
`);
